<template>

  <splitpanes class="default-theme" >

    <!-- 工作流可视化 -->
    <pane min-size="50" size="65">
      <div ref="graph_container" class="graph_container"></div>
    </pane>

    <pane min-size="25" >
      <splitpanes horizontal>
        <!-- 工作流表头、已提交的表单展示 -->
        <pane min-size="50" size="65">

          <el-form :model="processData" label-width="60px" style="margin-top: 10px;border-bottom: 2px solid #e5e5e5" >
            <el-row>
              <el-col :span="12">
                <el-form-item >
                  {{ this.$t('label1') }}
                  <span>{{processData.template_name}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item >
                  {{ this.$t('label3') }}
                  <span>{{ processData.create_user_name }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item >
                  {{ this.$t('label2') }}
                  <span>{{processData.id}}</span>
                </el-form-item>

              </el-col>
              <el-col :span="12">
                <el-form-item >
                  {{ this.$t('label4') }}
                  <span>{{processData.create_time}}</span>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>

          <!-- 节点已提交内容 -->
          <div class="form_box">
            <div class="form_switch_toolbar" v-if="this.currentNodeFormDataList.length > 1" >
              <el-button :class="getButtonClass(index)" size="small"
                         v-for="(formData,index) in currentNodeFormDataList"
                         @click="this.currentFormIdx = index">{{ (index + 1) }}</el-button>
            </div>
            <div v-for="(formData,index) in currentNodeFormDataList" >
              <div v-show="index===this.currentFormIdx" class="form_title" >
                <div style="margin-right: 60px" >{{formData.node_name}}</div>
                <div style="margin-right: 60px" >{{formData.submit_user_name}}</div>
                <div >{{formData.submit_time}}</div>
              </div>
              <FrameForm v-show="index===this.currentFormIdx" :component-param="formData.form_id" :readonly="true" :key="formData.id"
                         :init-data="formData"></FrameForm>
            </div>
          </div>
        </pane>

        <!-- 当前任务的提交表单 -->
        <pane min-size="20" >
          <div v-if="taskActive" class="form_title" >
            <div style="margin-right: 60px" >{{processData.current_task_node}}</div>
          </div>
          <FrameForm
              :component-param="currentTaskForm"
              init-url="/prc/getFormInitData"
              :auto-init="false"
              v-if="taskActive"
              ref="currentTaskForm"
              :parentData="parentData"/>
        </pane>

      </splitpanes>
    </pane>
  </splitpanes>

</template>

<script>

const messages = {
  zhCn: {
    label1:'工作流类型:',
    label2:'工作流编号:',
    label3:'创建用户:',
    label4:'创建时间:',
    label5:'期望完成时间:',
    label6:'流程超时:',
    label7:'流程图',
    label8:'流程日志',
    label9:'时间',
    label10:'执行用户',
    label11:'流程节点',
    label12:'操作类型',
    check_page2:'该任务已提交过！',
    check_page1:'参数工作流任务ID为空！',
    error1:'获取表单定义信息失败，',
  },
  en: {
    label1:'Workflow type:',
    label2:'Workflow number:',
    label3:'Create user:',
    label4:'Creation time:',
    label5:'Expected completion time:',
    label6:'Process timed out:',
    label7:'Flow Chart',
    label8:'Process Logs',
    label9:'Time',
    label10:'Executing user',
    label11:'Process node',
    label12:'Type of operation',
    check_page2:'The task has been submitted！',
    check_page1:'The parameter Workflow task ID is empty',
    error1:'Failed to get form definition information，',
  }
}

import { mxGraph, mxConstants, mxEvent, mxEdgeStyle} from 'mxgraph-js'
import { Splitpanes, Pane } from 'splitpanes'
import 'splitpanes/dist/splitpanes.css'

export default {
  name: "PrcHandle",
  i18n:{messages},
  components: {Splitpanes, Pane},
  props: {
      componentParam: {
          type: String,
          required: true
      },
      parentData: {
          type: Object,
          default() {
              return {}
          }
      },
      setting: {
          type: Object,
          default() {
              return {}
          }
      }
  },
  data() {
    return {
      processData: {},
      formDataList: [],
      currentNodeFormDataList: [],
      currentNodeId: '',
      logs: [],
      taskActive: true,
      currentTaskForm: '',
      currentFormIdx:0,
      nodes: [],
      routes: []
    }
  },
  methods: {

    loadPrcTaskInfo() {

      if (!this.parentData || !this.parentData.id) {
        return this.$message.error(this.$t('check_page1'));
      }

      var id = this.parentData.id;
      let url = '/prc/getPrcTaskInfo?id=' + id
      this.$axios.get(url).then(response => {
        let res = response.data;
        if (res.code !== 0) {
          return this.$message.error(res.message);
        }

        this.processData = res.data;
        this.logs = res.data?.logs || [];
        this.taskActive = res.data?.task_active || false;

        this.drawProcess(res.data);

        //初始化任务表单
        if(this.taskActive){
          this.currentTaskForm = this.processData.current_task_form;
          if (this.currentTaskForm) {
            this.$refs.currentTaskForm.initForm();
          }
        }

      }, error => {
        return this.$message.error((this.$t('error1', {msg: error.message}) + error.message));
      })

    },

    getButtonClass(index){
      if(this.currentFormIdx === index){
        return "form_switch_button_active";
      }
      return "form_switch_button";
    },

    drawProcess(processData){
      console.log("drawProcess start...")
      if(!processData){
        return this.$message.error(`工作流数据为空！`);
      }

      this.processData = processData;
      let templateObj = processData.template;
      this.nodes = templateObj?.nodes || [];
      this.formDataList = processData.form_data_list;

      if(this.nodes.length == 0){
        return ;
      }

      this.drawImage();

      //默认显示第一个节点的表单内容
      if(this.formDataList.length > 0){
        var formData = this.formDataList[0];
        this.currentNodeId = formData.node_id;
        this.setCurrentForms();
      }
    },
    setCurrentForms(){
      var cleared = false;
      if(!this.currentNodeId || this.currentNodeId.length == 0){
        return;
      }

      for(var i=0;i<this.formDataList.length;i++){
        var formData = this.formDataList[i];
        if(formData.node_id && this.currentNodeId == formData.node_id){
          if(!cleared){
            this.currentNodeFormDataList.lenth = 0;
            this.currentNodeFormDataList = [];
          }

          cleared = true;
          this.currentNodeFormDataList.push(formData);
        }
      }

      this.currentFormIdx = this.currentNodeFormDataList.length-1;

      //强制更新视图
      this.$forceUpdate();
    },
    drawImage(){
      console.log("drawImage start");
      // 创建画布
      var graph = new mxGraph(this.$refs.graph_container);
      graph.setEnabled(false); //设置启用,就是允不允许你改变CELL的形状内容。
      graph.setVertexLabelsMovable(false);

      var style = graph.getStylesheet().getDefaultEdgeStyle();
      style[mxConstants.STYLE_EDGE] = mxEdgeStyle.ElbowConnector; //自己拐弯的连线
      style[mxConstants.STYLE_FONTSIZE] = 16; //文字大小
      style[mxConstants.STYLE_FONTCOLOR] = "ff00ff";
      graph.getView().updateStyle = true; // 动态改变样式

      var parent = graph.getDefaultParent();
      //开始更新画布
      graph.getModel().beginUpdate();

      var that = this;
      //添加点击事件
      graph.addListener(mxEvent.CLICK, function(sender, evt)
      {
        //console.log('click in ...');
        var e = evt.getProperty('event'); // mouse event
        var cell = evt.getProperty('cell'); // cell may be null
        if (cell != null)
        {
          var id = cell.id;
          that.currentNodeId = cell.id
          console.log('that.currentNodeId=' + that.currentNodeId);
          that.setCurrentForms();
          evt.consume();
        }
      });

      try {

        // 插入节点
        var nodeObjects = {}
        for(var i=0;i<this.nodes.length;i++){
          var nodeData= this.nodes[i];
          var id = nodeData.id;

          var style = this.getNodeStyle(nodeData);
          var cell = graph.insertVertex(parent, null, nodeData.name, nodeData.x, nodeData.y, 100, 60, style);
          cell.id = id
          cell.name = nodeData.name;
          nodeObjects[id] = cell;
        }

        //插入线条
        for(var i=0;i<this.nodes.length;i++) {
          var nodeData = this.nodes[i];
          var routes = nodeData.routes || [];
          for (var j = 0; j < routes.length; j++) {
            var routeData = routes[j];
            var fromId = routeData.source_node;
            var toId = routeData.target_node;

            if (nodeObjects[fromId] && nodeObjects[toId]) {
              var lineStyle = this.getRouteStyle(routeData);
              var hasBreakPoints = routeData.break_points && routeData.break_points.length > 0;
              var label = routeData.label||'';
              var edge = graph.insertEdge(parent, null, label, nodeObjects[fromId], nodeObjects[toId], lineStyle);
              //设置折线点
              if(hasBreakPoints){
                edge.geometry.points = routeData.break_points
              }
            }
          }
        }
      } finally {
        // 画布更新结束
        graph.getModel().endUpdate();
      }
    },
    getNodeStyle(nodeData){
      var style = 'fontSize=14';
      if(nodeData.current) {
        style = style + ';strokeColor=orange;strokeWidth=3';
      }else if(nodeData.finish) {
        style = style + ';strokeColor=#33cc66;strokeWidth=3';
      }

      if(nodeData.disabled) {
        style = style + ';fillColor=#aaa;strokeWidth=1';
      }else if(nodeData.fill_color) {
        style = style + ';strokeWidth=1;fillColor=' + nodeData.fill_color;
      }

      if(nodeData.start || nodeData.end){
        style = style + ';rounded=1;perimeter=ellipsePerimeter;arcSize=30';
      }

      if(nodeData.font_color) {
        style = style + ';fontColor=' + nodeData.font_color;
      }
      return style;
    },
    getRouteStyle(routeData){
      var normalStyle = 'edgeStyle=elbowEdgeStyle;';
      var activeStyle = 'edgeStyle=elbowEdgeStyle;strokeWidth=3;strokeColor=#33cc66';
      var lineStyle = normalStyle;
      if (routeData.finish) {
        lineStyle = activeStyle;
      }else if (routeData.color) {
        lineStyle = normalStyle + "strokeColor=" + routeData.color;
      }
      return lineStyle;
    }

  },
  mounted() {
    this.loadPrcTaskInfo();
  }
}
</script>


<style lang="less" scoped>

.splitpanes__pane {
  background-color: white !important;
}

.splitpanes__splitter{
  background-color: whitesmoke !important;
}

.graph_container{
  background-color: white;
}

.form_switch_toolbar{
  display: inline-flex;
  padding: 5px;
}

.form_switch_button{
  display: inline-block;
  margin-right: -2px;
}

.form_switch_button_active{
  display: inline-block;
  margin-right: -2px;
  border-color: #0a84ff;
}

.form_title{
  background-color: whitesmoke;
  border: 1px solid #e5e5e5;
  height: 30px;
  line-height: 30px;
  padding-left: 80px;
  margin-top:-1px;
  width: 100%;
  display: inline-flex;

}

</style>
